<template lang="">
    <div enter-class="template-register__form">
        <slot name="content" v-bind="this"></slot>
    </div>
</template>
<script>
export default {
    data() {
        return {
            FirstName: "",
            LastName: "",
            Email: "",
            Password: "",
            formElement: null,
            fieldElements: {},
            errorsFormat: {},
            errorsFill: {},
            patternText:/^[a-zA-ZÀ-ÿ\u00f1\u00d1]+(\s[a-zA-ZÀ-ÿ\u00f1\u00d1])*[a-zA-ZÀ-ÿ\u00f1\u00d1]+([a-zA-Z\sÁÉÍÓÚáéíóúÑñ]+)$/,
            patternEmail: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,3}$/,
            patternPassword: /([A-Za-z0-9_]){8}$/,
            btnSubmit: "",
            isActive: false
        }
    },
    watch: {
        formElement(){
            this.findFields(this.formElement);
        }
    },
    methods: {
        findFields() {
            this.fieldElements["FirstName"] = document.querySelector("#FirstName");
            this.fieldElements["LastName"] = document.querySelector("#LastName");
            this.fieldElements["Email"] = document.querySelector("#Email");
            this.fieldElements["Password"] = document.querySelector("#CreatePassword");
        },
        validateFields() {
            this.findFields();

            let inputs = Object.keys(this.fieldElements);

            for(let i=0; i < inputs.length; i++){
                let input = inputs[i];

                if(this.fieldElements[input].value == "") {
                    this.errorsFill[this.fieldElements[input].id] = true;
                } else {
                    this.errorsFill[this.fieldElements[input].id] = false;
                }

                if(this.fieldElements[input].value !== "") {
                    this.validate(this.fieldElements[input].id, this.fieldElements[input].value);
                }
            }
        },
        handleConfirm({ target: { value, name, id } }) {
            this.validate(id, value);
        },
        validate(field, value) {
            switch (field) {
                case "FirstName":
                    if(this.patternText.test(this.FirstName) != true && this.FirstName.trim() == "") {
                        this.errorsFormat[field] = false;
                        this.errorsFill[field] = true;

                    } else if(this.patternText.test(this.FirstName) == true && this.FirstName.trim() != "") {
                        delete this.errorsFormat[field]
                        delete this.errorsFill[field];
                    
                    } else if(this.patternText.test(this.FirstName) == false && this.FirstName.trim() != "") {
                        this.errorsFormat[field] = true;
                        delete this.errorsFill[field];
                    }
                break;

                case "LastName":
                    if(this.patternText.test(this.LastName) != true && this.LastName.trim() == "") {
                        this.errorsFormat[field] = false;
                        this.errorsFill[field] = true;

                    } else if(this.patternText.test(this.LastName) == true && this.LastName.trim() != "") {
                        delete this.errorsFormat[field]
                        delete this.errorsFill[field];
                    
                    } else if(this.patternText.test(this.LastName) == false && this.LastName.trim() != "") {
                        this.errorsFormat[field] = true;
                        delete this.errorsFill[field];
                    }
                break;
                
                case "Email":
                    if(this.patternEmail.test(this.Email) != true && this.Email.trim() == "") {
                        this.errorsFormat[field] = false;
                        this.errorsFill[field] = true;

                    } else if(this.patternEmail.test(this.Email) == true && this.Email.trim() != "") {
                        delete this.errorsFormat[field]
                        delete this.errorsFill[field];
                    
                    } else if(this.patternEmail.test(this.Email) == false && this.Email.trim() != "") {
                        this.errorsFormat[field] = true;
                        delete this.errorsFill[field];
                    }
                break;
                
                case "CreatePassword":
                    if(!value ||  typeof(value) != "string"){
                        this.errorsFill[field] = true;
                    } else {
                        delete this.errorsFill[field]; 
                    }

                    if(value.length < 8) {
                        this.errorsFill.PasswordLength = true;
                    } else {
                        delete this.errorsFill.PasswordLength; 
                    }

                    if(value == this.Email.toString()) {
                        this.errorsFill.PasswordEmail = true;
                    } else {
                        delete this.errorsFill.PasswordEmail; 
                    }
                    
                    if(!/[a-z]/.test(value) || !/[A-Z]/.test(value) || value.replace(/[a-z0-9]*/ig,'').length < 1) {
                        this.errorsFill.PasswordSpecialChars = true;
                    } else {
                        delete this.errorsFill.PasswordSpecialChars; 
                    }
                break;
            }
        },
        submit(ev) {
            return new Promise((resolve, reject) => {
                this.validateFields();
                let objectError = JSON.parse(JSON.stringify(this.errorsFormat));
                let objectErrorFill = JSON.parse(JSON.stringify(this.errorsFill));

                if(Object.keys(objectError).length == 0 && Object.keys(objectErrorFill).length == 0) {
                    resolve("SUCCESS --> PASA VALIDACIÓN");
                    this.isActive = true;
                } else {
                    reject("FAIL --> NO PASA VALIDACIÓN");
                }

            }).then(result => {
                this.send().then(
                    ok => {
                        console.error("OK en envio", ok);
                        this.isActive = false;

                    }, error => {
                        console.error("Error en envio",error);
                    }
                );
            }).catch(error => {
                console.error(error); 
            });
        },
        send() {
            return new Promise(( resolve, reject ) => {
                document.getElementById('create_customer').submit();
                this.activeBtn();
            });
        },
        activeBtn() {
            if(this.isActive) {
                this.btnSubmit.disabled = true;
            } else {
                this.btnSubmit.disabled = false;
            }
        }
    },
    mounted() {
        console.warn("formRegister component mounted");
        this.btnSubmit = document.querySelector('.btnSubmit');
        setTimeout(() => {
            this.activeBtn();
        }, 500);
    }
}
</script>